export default "__VITE_ASSET__DCO1vhvT__"